import nubrakesLogo from '../../../public/img/nubrakes-logo.svg'
import discountTireLogo from '../../../public/img/discount-tire-logo.png'
import Image from 'next/image'
import backroundImage from '../../../public/img/nubrakes-discount@lighter.png'
import { DiscountTireForm } from '../Forms/DiscountTireForm'

export function DiscountTireHeader() {
  return (
    <div className="relative overflow-hidden min-h-[60vh] pb-3">
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          zIndex: -100,
          top: 0,
          left: 0,
        }}
      >
        <div className="py-8 flex flex-col justify-center align-center w-full h-full min-h-[60vh] ">
          <Image
            src={backroundImage}
            placeholder={'blur'}
            layout={'fill'}
            priority={true}
            objectFit={'cover'}
            objectPosition={'bottom center'}
            alt={'NuBrakes Discount Tire Header Image'}
          />
        </div>
      </div>
      <div className="flex flex-row justify-center">
        <div style={{ zIndex: 1 }} className="bg-gray-200 flex flex-row justify-center flex-shrink px-6 rounded-b-xl">
          <div className="py-2 px-6">
            <Image alt="Discount Tire Logo" src={discountTireLogo} priority={true} width={166} height={50} />
          </div>
          <div className="border-black border-2 my-2"></div>
          <div className="py-2 px-6">
            <Image alt="NuBrakes Logo" src={nubrakesLogo} priority={true} width={150} height={50} />
          </div>
        </div>
      </div>
      <div style={{ zIndex: 40 }} className="flex flex-col items-center middle mt-8 text-white [&>*]:z-10 px-">
        <h1 className="text-4xl lg:text-7xl tracking-wider">Discount Tire</h1>
        <h2 className="text-xl lg:text-4xl tracking-widest">Mobile Fleet Services</h2>
        <h4 className="bg-red-600 p-3 tracking-widest lg:text-xl text-sm">Powered By NuBrakes</h4>
      </div>
      <div className='max-w-xl mx-auto p-2'>
        <div className="bg-white p-3 rounded-md">
          <DiscountTireForm />
        </div>
      </div>
    </div>
  )
}
